import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getLocalidadClientes`, method: 'GET', body: null, token: token})
}
